
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/keycloak/callback",
      function () {
        return require("private-next-pages/auth/keycloak/callback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/keycloak/callback"])
      });
    }
  